<template>
  <div class="rewards" :class="cssType">
    <div class="btns">
      <ActButton type="blue" @click="goRecharge">
        {{ $t('accumRecharge.rewards.goRecharge') }}
      </ActButton>
      <ActButton type="blue" @click="showRecordDialog">
        {{ $t('accumRecharge.rewards.record') }}
      </ActButton>
      <ActButton :type="state.canReceiveOneKey ? 'blue' : 'grey'" @click="rewardsAll" :disabled="!state.canReceiveOneKey">
        {{ $t('accumRecharge.rewards.rewardsAll') }}
      </ActButton>
    </div>
    <div class="list">
      <div class="item" v-for="item in state.rewardList" :key="item.mergePrdCode">
        <div class="item-left">
          <div class="gear-name">
            <div>
              {{ item.mergePrdCount }}
            </div>
            <div>
              {{ $t('payment.product.diamond') }}
            </div>
          </div>
        </div>
        <div class="item-center">
          <GiftProp v-for="prop in formatPropsGift(item.propsGift)" :key="prop.propId" :prop="prop" />
        </div>
        <div class="item-right">
          <ActButton class="btn" type="blue" :size="isMobile ? 'large' : ''" v-if="getStatus(item) === 'canReceive'" @click="receiveReward(item)">
            {{ $t('accumRecharge.rewards.btnStatus.canReceive') }}
          </ActButton>
          <ActButton class="btn" type="grey" :size="isMobile ? 'large' : ''" v-if="getStatus(item) === 'received'" disabled>
            {{ $t('accumRecharge.rewards.btnStatus.received') }}
          </ActButton>
          <ActButton class="btn" type="yellow" :size="isMobile ? 'large' : ''" v-if="getStatus(item) === 'goRecharge'" @click="goRecharge">
            {{ $t('accumRecharge.rewards.btnStatus.goRecharge') }}
          </ActButton>
          <!-- 奖励领取时间结束后，服务端collectTimesLimit会返回0 -->
          <div class="limit" v-if="item.collectTimesLimit !== 0">
            {{ $t('accumRecharge.rewards.rewardTimes') }}
            <span>{{ item.canCollectTimes }}</span>/<span>{{ item.collectTimesLimit }}</span>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="state.recordDialog.visible" type="record">
      <RecordTable :recordList="state.rewardRecordList" v-if="!isMobile" />
      <MobileRecordTable :recordList="state.rewardRecordList" v-else />
    </Dialog>
    <Dialog v-model="state.rewardsAllDialog.visible" type="rewards-all">
      <div class="rewards-all-dialog-content">
        <div class="content-item" v-for="(item, index) in $t('accumRecharge.rewardsAllDialog.content').split('\n')" :key="index">
          {{ item }}
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.receiveRewardDialog.visible" type="rewards">
      <div class="receive-reward-dialog-content">
        <GiftProp v-for="prop in formatPropsGift(state.tempRewardsItem.propsGift)" :key="prop.propId" :prop="prop" />
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { reactive, watch, defineEmits, computed, onMounted, onUnmounted } from 'vue'
import { isMobile } from '@/utils'
import ActButton from '../ActButton/index.vue'
import { useRouter } from 'vue-router'
import Dialog from '@/components/Dialog/ActAccumRecharge/index.vue'
import GiftProp from './components/GiftProp/index.vue'
import RecordTable from './components/RecordTable/index.vue'
import MobileRecordTable from './components/MobileRecordTable/index.vue'
import AccumActApi from '@/config/accumActApi'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const store = useStore()
const router = useRouter()
const cssType = isMobile ? 'mobile' : 'pc'
const emit = defineEmits(['updateRewardList'])
watch(() => locale.value, () => {
  console.log('locale', locale.value)
  state.rewardList = []
  state.rewardRecordList = []
  reset()
})

const state = reactive({
  recordDialog: {
    visible: false,
  },
  rewardsAllDialog: {
    visible: false,
  },
  receiveRewardDialog: {
    visible: false,
  },
  rewardList: [],
  cpUserInfo: computed(() => store.state.cpUserInfo),
  rewardRecordList: [],
  canReceiveOneKey: computed(() => { // 是否可以一键领取
    return state.rewardList.some(item => getStatus(item) === 'canReceive')
  }),
  tempRewardsItem: {},
})

watch(() => state.cpUserInfo, () => {
  reset()
}, { deep: true })

const goRecharge = () => {
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}

const showRecordDialog = () => {
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  getRewardRecordList()
  state.recordDialog.visible = true
}

const rewardsAll = () => {
  console.log('rewardsAll', state.cpUserInfo.cpUserId, state.canReceiveOneKey)
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (!state.canReceiveOneKey) {
    return
  }
  oneKeyCollect()
}

const getRewardList = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumActApi.getRewardList(params)
  const list = res.list || []
  list.sort((a, b) => a.mergePrdCount - b.mergePrdCount)
  state.rewardList = res.list || []
}

const formatPropsGift = (propsGiftJsonStr) => {
  const propsGift = JSON.parse(propsGiftJsonStr)
  return propsGift
}

const getRewardRecordList = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumActApi.getRewardRecordList(params)
  console.log('getRewardRecordList', res)
  // debugger
  if (res.list) {
    state.rewardRecordList = res.list
  } else {
    state.rewardRecordList = []
  }
}

const getStatus = (item) => {
  // collectTimesLimit 奖励领取次数上限(活动配置)
  // collectedTimes 已领奖励次数
  // canCollectTimes 当前可领奖励次数上限
  if (item.collectTimesLimit === 0) { // 奖励领取时间结束后，服务端collectTimesLimit会返回0，统一展示goRecharge按钮
    return 'goRecharge'
  }
  if (item.collectedTimes >= item.collectTimesLimit) {
    return 'received'
  }
  if (item.collectedTimes < item.canCollectTimes) {
    return 'canReceive'
  }
  if (item.canCollectTimes < item.collectTimesLimit) {
    return 'goRecharge'
  }
  console.error('getStatus error', item)
}

const receiveReward = async (item) => {
  console.log('receiveReward', item)
  state.tempRewardsItem = item
  const params = {
    buyId: item.buyId,
  }
  const res = await AccumActApi.collectReward(params)
  console.log('collectReward', res)
  state.receiveRewardDialog.visible = true
  reset()
}

const oneKeyCollect = async () => {
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumActApi.oneKeyCollect(params)
  console.log('oneKeyCollect', res)
  state.rewardsAllDialog.visible = true
  reset()
}

watch(() => state.rewardList, () => {
  emit('updateRewardList', state.rewardList)
})

const init = () => {
  getRewardList()
}

const reset = () => {
  init()
}

init()

let count = 0

// 监听页面显示出来的时候就重新获取rewardList
onMounted(() => {
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      console.log('reset', count++)
      reset()
    }
  }
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 组件卸载时移除监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
})

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
